import memoizeOne from 'memoize-one';
import type { TimelineDuration, ColumnDuration } from '../../../../model/timeline';
import { getDatePercentage, getTotalMilliseconds } from '../../../../utils/timeline';

// Given the date range of each column, gets the relative position of each column on the timeline
export const getColumnPositions = memoizeOne(
	(timelineDuration: TimelineDuration, columnDurations: ColumnDuration[]): [number, number][] => {
		let left = 0;
		if (columnDurations.length > 0) {
			// Column start can be earlier than the timeline start. This means the first column left can be a negative value.
			// Example where this can happen is in the export table where the timeline duration is clamped to the selected date range.
			left =
				getDatePercentage(
					columnDurations[0].startDate,
					timelineDuration.startDate,
					timelineDuration.endDate,
				) * 100;
		}
		const timelineTotalMilliseconds = getTotalMilliseconds(timelineDuration);
		return columnDurations.map((columnDuration) => {
			const width = (getTotalMilliseconds(columnDuration) / timelineTotalMilliseconds) * 100;
			left += width;

			return [left - width, 100 - left] as const;
		});
	},
);

// Finds the index of the column which contains todays date
export const getTodayColumnIndex = memoizeOne((today: Date, columnDurations: ColumnDuration[]) => {
	let todayColumnIndex = 0;
	columnDurations.some(({ startDate, endDate }) => {
		if (today >= startDate && today < endDate) {
			return true;
		}

		todayColumnIndex += 1;
		return false;
	});

	return todayColumnIndex;
});
